import React from 'react';
import PropTypes from 'prop-types';
import './EndorsementTimeLimitNotice.scss';

// `detailed` is the endorsements landing page variant: it carries the icon and
// spells out what happens when an application lapses. The wizard shows the plain
// short form below the stepper on every step.
export const EndorsementTimeLimitNotice = ({ detailed }) => (
   <div className="endorsement-time-limit-notice">
      <strong className="endorsement-time-limit-notice-heading">
         {detailed && <i className="material-icons">error</i>}
         {detailed ? 'Important' : 'Application time limit'}
      </strong>
      <p>You must complete your application within 30 days of starting it.</p>
      {detailed && (
         <p>
            Applications that are not completed within 30 days will be
            cancelled. If your application is cancelled, you will need to submit
            a new application.
         </p>
      )}
   </div>
);

EndorsementTimeLimitNotice.propTypes = {
   detailed: PropTypes.bool,
};

EndorsementTimeLimitNotice.defaultProps = {
   detailed: false,
};

// Row-wrapped variant so each wizard step can drop it straight below the stepper.
const EndorsementTimeLimitNoticeRow = () => (
   <div className="container">
      <div className="row">
         <div className="col s10 m10 l10 offset-l1">
            <EndorsementTimeLimitNotice />
         </div>
      </div>
   </div>
);

export default EndorsementTimeLimitNoticeRow;
